export interface TimeframeConfig {
  start: string;
  end: string;
  ticks: string[];
}

export interface CustomerBudgetData {
  year: string;
  confirmed: number;
  projected: number;
  weighted: number;
  minimum: number;
}

export interface TimeAllocationData {
  data: {
    year: string;
    [key: string]: string | number;
  }[];
  customers: string[];
  colors: { [key: string]: string };
}

export interface ProjectTypeData {
  year: string;
  ourIp: number;
  ipOpportunity: number;
  other: number;
  ourIpProjects: string[];
  ipOpportunityProjects: string[];
  otherProjects: string[];
}

export interface ProfitabilityData {
  customerName: string;
  timeAllocation: number;
  budgetAllocation: number;
  profitabilityIndex: number;
  totalBudget: number;
  monthlyBudget: number;
  color?: string;
}

export interface ForecastData {
  year: string;
  confirmed: number;
  projected: number;
  weighted: number;
  minimum: number;
}

export interface CustomerBudgetMap {
  color?: string;
  total: number;
  years: { [key: string]: number };
  projects: { [key: string]: any[] };
}

export interface TimeMap {
  color?: string;
  years: { [key: string]: number };
}

export interface ProcessedBudget {
  customerName: string;
  color?: string;
  totalBudget: number;
  projects: { [key: string]: any[] };
  [key: string]: any;
}

export const monthToNumber: { [key: string]: number } = {
  'January': 0,
  'February': 1,
  'March': 2,
  'April': 3,
  'May': 4,
  'June': 5,
  'July': 6,
  'August': 7,
  'September': 8,
  'October': 9,
  'November': 10,
  'December': 11
};